import { Component, computed, inject, signal } from '@angular/core';
import { RouterLink } from "@angular/router";
import { SignalsStoreService } from '../signals-store.service';

@Component({
  selector: 'app-footer',
  imports: [RouterLink],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss'
})
export class FooterComponent {

  //#region Services

  #signalsStoreService = inject(SignalsStoreService);

  //#endregion

  //#region Properties

  logoVersionNumber = computed(() => this.#signalsStoreService.logoVersionNumber());
  
  copyRightYear = new Date().getFullYear();

  menu = signal([
    {
      header: 'Explore',
      items: [
        {
          text: 'Market',
          link: '/shop',
          show: signal(true)
        },
        {
          text: 'Find Us',
          link: '/pages/atlanta-delivery-schedule',
          show: signal(true)
        },
        {
          text: 'About',
          link: '/pages/family-and-team',
          show: signal(true)
        }, {
          text: 'Blog',
          link: '/pages/blog',
          show: signal(true)
        },
      ]
    },
    {
      header: 'Support',
      items: [
        {
          text: 'FAQ',
          link: '/pages/faq',
          show: signal(true)
        },
        {
          text: 'Contact',
          link: '/pages/contact-us',
          show: signal(true)
        }, {
          text: 'Privacy Policy',
          link: '/pages/privacy-policy',
          show: signal(true)
        },
      ]
    },
    {
      header: 'My Account',
      items: [
        {
          text: 'Sign In',
          link: '/log-in',
          show: computed(() => !this.#signalsStoreService.hasSession())
        },
        {
          text: 'Buy a gift card!',
          link: '/pages/gift-cards',
          show: signal(true)
        }
      ]
    },
  ]);

  //#endregion



  scrollToTop(): void {
    const divToScroll = document.getElementById('scroll-to-top-ref');
    if (divToScroll) {
      divToScroll.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  openNewTab(url: string) {
    window.open(url, '_blank');
  }
}

